import type { SvgIconProps } from "@mui/material";

import baselineSvg from "./min-icon.baseline.svg?react";
import textSvg from "./min-icon.text.svg?react";
import { makeSvgIcon } from "./svg-icon";

const MinIconBaseline = makeSvgIcon(baselineSvg);
const MinIconText = makeSvgIcon(textSvg);

export function MinIcon({
  text = true,
  ...props
}: SvgIconProps & { text?: boolean }) {
  return text ? <MinIconText {...props} /> : <MinIconBaseline {...props} />;
}

export default MinIcon;
